import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SpotFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const regionOptions = [
    { value: 'all', label: 'Tüm Bölgeler' },
    { value: 'marmara', label: 'Marmara' },
    { value: 'ege', label: 'Ege' },
    { value: 'akdeniz', label: 'Akdeniz' },
    { value: 'karadeniz', label: 'Karadeniz' },
    { value: 'ic-anadolu', label: 'İç Anadolu' }
  ];

  const difficultyOptions = [
    { value: 'all', label: 'Tüm Seviyeler' },
    { value: 'Başlangıç', label: 'Başlangıç' },
    { value: 'Orta', label: 'Orta' },
    { value: 'İleri', label: 'İleri' }
  ];

  const amenityOptions = [
    { value: 'parking', label: 'Otopark' },
    { value: 'shower', label: 'Duş' },
    { value: 'rental', label: 'Kiralama' },
    { value: 'cafe', label: 'Kafe/Restoran' },
    { value: 'storage', label: 'Malzeme Deposu' }
  ];

  const handleSearchChange = (e) => {
    onFilterChange({ ...filters, search: e?.target?.value });
  };

  const handleRegionChange = (value) => {
    onFilterChange({ ...filters, region: value });
  };

  const handleDifficultyChange = (value) => {
    onFilterChange({ ...filters, difficulty: value });
  };

  const handleAmenitiesChange = (values) => {
    onFilterChange({ ...filters, amenities: values });
  };

  const hasActiveFilters = 
    filters?.search || 
    filters?.region !== 'all' || 
    filters?.difficulty !== 'all' || 
    filters?.amenities?.length > 0;

  return (
    <div className="bg-card rounded-xl shadow-organic p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-5 lg:mb-6">
        <h2 className="text-lg md:text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} />
          Filtreler
        </h2>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Temizle
          </Button>
        )}
      </div>
      <div className="space-y-4">
        <Input
          type="search"
          placeholder="Spot adı veya konum ara..."
          value={filters?.search}
          onChange={handleSearchChange}
          className="w-full"
        />

        <Select
          label="Bölge"
          options={regionOptions}
          value={filters?.region}
          onChange={handleRegionChange}
        />

        <Select
          label="Zorluk Seviyesi"
          options={difficultyOptions}
          value={filters?.difficulty}
          onChange={handleDifficultyChange}
        />

        <Select
          label="Olanaklar"
          description="Birden fazla seçim yapabilirsiniz"
          options={amenityOptions}
          value={filters?.amenities}
          onChange={handleAmenitiesChange}
          multiple
          searchable
        />

        <div className="pt-2">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Info" size={14} />
            <span>Haritada işaretli spotları görmek için yakınlaştırın</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpotFilters;